module.exports = __webpack_public_path__ + "img/nt55-04-80-1-asm.prt.42f10c20.jpg";